<!-- ======================  图片+视频预览 ================================= -->
<template>
  <transition :name=' transition === false ? "" : transition || "el-zoom-in-center" ' >
  <div id="ImageVideo" v-show='show'>

    <!-- <el-dialog 
      ref='dialog'
      width="100%"
      :visible.sync="actived" 
      :fullscreen="true" 
      :show-close='false' 
      @opened='fullScreen' 
      @closed='OwnAllAuth=true,exitScreen()'
      vview z:next='e.firstElementChild.children[1].style.paddingRight=#isCol?"1px":"9px"'> -->
    
      <el-row style="margin:10px 0px;display: flex;align-items: baseline;">
        <span v-set:number='4'></span>
        <el-col :span='number' style='padding-left: 7px;padding-right: 7px;'>
          <el-button 
            @click="$emit('update:show',false),show=$host[$hostshow]=false,window.sleep(200).then(v=>transition=transitions[ A.random(0,6) ])" 
            class='el-icon-close font14' 
            size='small' 
            type="danger" 
            style='border-radius: 1px;width: 100%;background: var(--Colorlight);border-top-left-radius: 17px;border-bottom-left-radius: 17px;'>
              <span style="margin-left:7px">返回</span>
          </el-button>
        </el-col>

        <el-col :span='24-number'>
          <h2 class="tCenter blackFont " xstyle="position: absolute;top: -54px;width: 100%;z-index: 5;line-height: 41px;">
            <span class='cPointer' @click=''>{{ "哈哈哈哈" }}</span>
          </h2>
        </el-col>

      </el-row>
      
      <el-row :gutter="20"  v-set:Data.style='{ height: iscreen ? "92vh" : "calc(100vh - 58px)" }'>
        
        <el-col :span="number" style='padding:0px;'>
          <el-menu
            :default-active="defaultActive"
            class="el-menu-vertical-demo"
            x:unique-opened="isOpenOne"
            :collapse="isCollapse"
            :background-color="window.$Themecolor"
            text-color="#fff"
            active-text-color="#fff"
            style='height:calc(100vh - 49px);overflow-x: hidden!important;overflow-y: auto!important;'
            :style='Data.style' >
          
          <div 
            v-for="item in urls" :key="item.uid" 
            vif='item' 
            @click.stop='defaultActive = index+1+"", mindex === item'>
          
          <el-tooltip effect="dark" :content='item.url' placement="right">
            <el-menu-item
              :index="index+1+''"  x:title='item.url'
              x:ref=' mindex === item ? ( $nextTick((e=>(e=$refs.true) && e[0] && e[0].$el.scrollIntoViewIfNeeded()).waitSleep(50)), true ) : "" '
              :show-timeout='50' :hide-timeout='50'
              class="menuItem" style='overflow: hidden;text-overflow: ellipsis;' >
              <i style="">
                {{ index + 1 + ") " }}
              </i>
              <span>{{item.url}}</span>
            </el-menu-item>
          </el-tooltip>
          
          </div>

          </el-menu>
        </el-col>
                
        <el-col :span="24-number" class='rPos' style='padding:0px;'>
          <!-- <h2 class="tCenter blackFont " style="position: absolute;top: -54px;width: 100%;z-index: 5;line-height: 41px;">
            <span class='cPointer' @click=''>{{ mindex.url }}</span>
          </h2> -->

          <!-- '#pagemode=thumbs&navpanes=0&toolbar=0&statusbar=0&view=FitV' -->
          <embed
            ref='embed'
            v-if="OwnAllAuth && ( showPdf || showVedio ) && pdtSrc"
            :src=" OwnAllAuth && pdtSrc ? pdtSrc : '' "
            :style='Data.style'
            style="width:100%;height:calc(100% - 49px);"
            type="application/pdf"
            load='fullScreen'
          />

          <video 
            v-if='!OwnAllAuth && showVedio' id="MyVideo" ref='MyVideo'
            :src="pdtSrc || ''" 
            :style='Data.style' 
            xoncontextmenu='return false'
            style='width:100%;height:calc(100% - 49px);background: black;' 
            aloop autoplay controls
            >
          </video>

          <!-- a:src=" !OwnAllAuth && pdtSrc ? '../../static/pdfJS/web/viewer.html?file=2.pdf' : '' " --> 
          <iframe 
            ref='embed'
            v-else-if='!OwnAllAuth && !showVedio'
            v-show="showPdf"
            frameborder="0" 
            :src=" !OwnAllAuth && pdtSrc ? '../../static/pdfJS/web/viewer.html?file=' + pdtSrc : '' " 
            :style='Data.style'
            style="width:100%;height:calc(100% - 49px);"
            load='fullScreen'
            ></iframe>

          <!-- <media-player :navs="vedio" v-if="showVedio"></media-player> -->
        </el-col>

      </el-row>

    <!-- </el-dialog> -->

  </div>
  </transition>
</template>
<script>

export default {
  props: [ "urls", "itransition", "ishow" ],
  data() {
    return {
      show: false,
      transition: '',
      showPdf: false,
      showImage: false,
      showVedio: true,
      pdtSrc: ' ',
      urls: [ ],
      transitions: [
        'el-zoom-in-top',
        'el-fade-in-linear',
        'el-zoom-in-center',
        'el-zoom-in-bottom',
        'el-fade-in',
      ],

      vedio: {
        type: 0, //0音频,1视频
        url: ""
      }, //音视频组件传值

      isCollapse: false,
      defaultActive: '1', mindex: '1',
      minCol: 4,
      iscreen: false,
      OwnAllAuth: true,
      
    };
  },

  methods: {

    tableRowClassName({ row, rowIndex }) {
      if (row.parentid == 0) {
        return "success-row";
      }
      return "";
    },


    fullScreen(e){
      console.error(this.$refs);
      // this.$refs.embed._load = true;
      // ( e = $.fullScreen() );
    },
    exitScreen(e) {
      // e = $.exitScreen();
    },


  },
  watch: {

  },

  beforeCreate() {
    
  },

  created() {
    forEach(this.$attrs,(bindvalue,bindkey)=>{
      if( bindkey === 'show' || bindkey.startsWith('show') ) {
        const $host = this.$host = this.$host || this.$vnode.context;
        this.transition = bindkey.slice(5);
        // console.error(this.transition, bindvalue, bindkey);
        this.$unwatch = $host.$watch(this.$hostshow=bindvalue,bool=>{
          this.show = bool;
        },{immediate: true});
        return true;
      };
    });
    // console.error( (window.b = this).transition );
  },

  destroyed() {
    this.$unwatch && this.$unwatch();
  },

  mounted() {
    
  },

};
</script>
<style scoped>
  #MyVideo::-webkit-media-controls-enclosure {
    overflow: hidden;
    width: calc(100% + 80px);
    box-sizing: border-box;
    padding-left: 25px;
    margin: auto 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/$Image-Video.vue